/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateMcpEndpointForm,
  UpdateMcpEndpointForm$Outbound,
  UpdateMcpEndpointForm$outboundSchema,
} from "../components/updatemcpendpointform.js";

export type UpdateMcpEndpointSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateMcpEndpointSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateMcpEndpointSecurity = {
  option1?: UpdateMcpEndpointSecurityOption1 | undefined;
  option2?: UpdateMcpEndpointSecurityOption2 | undefined;
};

export type UpdateMcpEndpointRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateMcpEndpointForm: UpdateMcpEndpointForm;
};

/** @internal */
export type UpdateMcpEndpointSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateMcpEndpointSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateMcpEndpointSecurityOption1$Outbound,
  UpdateMcpEndpointSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateMcpEndpointSecurityOption1ToJSON(
  updateMcpEndpointSecurityOption1: UpdateMcpEndpointSecurityOption1,
): string {
  return JSON.stringify(
    UpdateMcpEndpointSecurityOption1$outboundSchema.parse(
      updateMcpEndpointSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateMcpEndpointSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateMcpEndpointSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateMcpEndpointSecurityOption2$Outbound,
  UpdateMcpEndpointSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateMcpEndpointSecurityOption2ToJSON(
  updateMcpEndpointSecurityOption2: UpdateMcpEndpointSecurityOption2,
): string {
  return JSON.stringify(
    UpdateMcpEndpointSecurityOption2$outboundSchema.parse(
      updateMcpEndpointSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateMcpEndpointSecurity$Outbound = {
  Option1?: UpdateMcpEndpointSecurityOption1$Outbound | undefined;
  Option2?: UpdateMcpEndpointSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateMcpEndpointSecurity$outboundSchema: z.ZodMiniType<
  UpdateMcpEndpointSecurity$Outbound,
  UpdateMcpEndpointSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateMcpEndpointSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateMcpEndpointSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateMcpEndpointSecurityToJSON(
  updateMcpEndpointSecurity: UpdateMcpEndpointSecurity,
): string {
  return JSON.stringify(
    UpdateMcpEndpointSecurity$outboundSchema.parse(updateMcpEndpointSecurity),
  );
}

/** @internal */
export type UpdateMcpEndpointRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateMcpEndpointForm: UpdateMcpEndpointForm$Outbound;
};

/** @internal */
export const UpdateMcpEndpointRequest$outboundSchema: z.ZodMiniType<
  UpdateMcpEndpointRequest$Outbound,
  UpdateMcpEndpointRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateMcpEndpointForm: UpdateMcpEndpointForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateMcpEndpointForm: "UpdateMcpEndpointForm",
    });
  }),
);

export function updateMcpEndpointRequestToJSON(
  updateMcpEndpointRequest: UpdateMcpEndpointRequest,
): string {
  return JSON.stringify(
    UpdateMcpEndpointRequest$outboundSchema.parse(updateMcpEndpointRequest),
  );
}
